<template>
  <div class="company-inner-header" :class="{ 'company-inner-header-active': active }">
    <transition name="show">
      <div class="text-group" v-if="!active">
        <p class="text-light" v-if="title">{{title}}</p>
      </div>
    </transition>
    <div class="contact-form-wrapper" id="contactForm">
      <div class="contact-form-btn" @click="active = true">
        <div class="contact-form-btn-text">
          <h3 class="text-main-home">{{ $t('kcm-group-companies-1') }}</h3>
          <h2 class="text-main-home">{{ $t('kcm-group-companies-2') }}</h2>
        </div>
        <!-- BLUE CIRCLE BTN -->
        <span class="kcm circle-btn">
          <transition name="scale" mode="out-in">
            <span v-if="!active" :key="'icon1'">V</span>
            <span v-else class="kcm" :key="'icon2'" @click.stop="active = false">J</span>
          </transition>
        </span>
      </div>
      <transition name="show">
        <form v-if="active" @submit.prevent="submit()" class="contact-form">
          <div class="row">
            <div class="input-wrapper">
              <input type="text" v-model="inquiry.name" :placeholder="$t('kcm-group-form-1')" />
            </div>
            <div class="input-wrapper">
              <input type="text" v-model="inquiry.phone" :placeholder="$t('kcm-group-form-2')" />
            </div>
            <div class="input-wrapper">
              <input type="email" v-model="inquiry.email" placeholder="e-mail" />
            </div>
          </div>
          <div class="row">
            <div class="textarea-wrapper">
              <textarea
                cols="30"
                rows="10"
                v-model="inquiry.message"
                :placeholder="$t('kcm-group-form-3')"
              ></textarea>
            </div>
          </div>
          <div class="row form-submit-row">
            <p>
              {{ $t('kcm-group-form-4') }}
              <router-link to="/sustainability?page=gdpr">{{ $t('kcm-group-form-5') }}</router-link>
            </p>
            <div class="text-group">
              <div class="captcha-and-submit">
                <div class="captcha-wrapper" v-if="captcha">
                  <p
                    v-if="captcha.numOne && captcha.numTwo"
                  >{{ captcha.numOne }} + {{ captcha.numTwo }} =</p>
                  <div class="input-wrapper">
                    <input type="text" v-model="inquiry.captchaSum" />
                  </div>
                </div>
                <a class="link" @click.prevent="submit()">
                  <span class="text-color">{{ $t('send') }}</span>
                </a>
              </div>
            </div>
          </div>
        </form>
      </transition>
      <transition name="show">
        <div v-if="active" class="contact-form-info">
          <div class="contacts-form-info-item" v-for="(c, i) in contacts" :key="`contacts-${i}`">
            <p v-for="(item, key, j) in c" :key="`$contacts-${i}-${j}`">
              <template v-if="key !== 'title'">
                <span class="strong">{{ $t(key) }}:</span>
                <a :href="item.url" target="_blank">{{item.text}}</a>
              </template>
              <span v-else class="strong title-p">{{ item }}</span>
            </p>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import inquiry from '../../mixins/inquiry.js';
import captcha from '../../mixins/captcha.js';
export default {
  props: ['title', 'email', 'contacts', 'company'],
  mixins: [inquiry, captcha],
  watch: {
    '$route.query'(to, from) {
      if (!from.contacts) {
        this.close();
      }
    },
    company() {
      this.inquiry.category = this.company;
    },
    email() {
      this.inquiry.to = this.email;
    }
  },
  data() {
    return {
      active: this.$route.query.contacts ? true : false,
      captcha: '',
      inquiry: {
        name: '',
        phone: '',
        email: '',
        category: this.company,
        categoryTitle: 'Относно дружество от холдинга',
        message: '',
        captchaSum: '',
        to: this.email,
        url: this.$t('inquiry-8')
      }
    };
  },
  methods: {
    close() {
      if (window.innerWidth > 800) {
        this.active = false;
      }
    },
    handleState() {
      if (window.innerWidth < 800) {
        this.active = true;
      }
    },
    handleResize() {
      this.handleState();
    },
    submit() {
      this.sendMail(this.inquiry, this.captcha)
        .then(() => {
          this.inquiry.name = '';
          this.inquiry.phone = '';
          this.inquiry.email = '';
          this.inquiry.message = '';
          this.inquiry.captchaSum = '';

          this.captcha = this.getCaptcha();
          this.close();
        })
        .catch(() => {});
    }
  },
  mounted() {
    this.handleState();

    this.captcha = this.getCaptcha();
    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style lang="scss" scoped>
.company-inner-header {
  display: flex;
  height: 100px;
  left: 0;
  margin-bottom: 20px;
  position: absolute;
  top: 20px;
  width: 100%;
  @include transition(all 0.6s $mainCubic);
  @include transform(translateX(-50px));
  z-index: 1;
  > .text-group {
    align-items: center;
    background-color: rgba(22, 65, 148, 0.9);
    display: flex;
    height: 100%;
    padding: 10px;
    position: absolute;
    width: 60%;
    p {
      margin: 0;
    }
  }
  .contact-form-wrapper {
    background-color: #e8edef;
    display: flex;
    flex-direction: column;
    height: 100%;
    left: 60%;
    overflow: hidden;
    margin-left: 20px;
    position: absolute;
    @include transition(all 0.6s $mainCubic);
    width: 40%;
    .contact-form-btn {
      min-height: 100px;
      align-items: center;
      @include transition(all 0.6s $mainCubic);
      cursor: pointer;
      display: flex;
      height: 100px;
      justify-content: space-between;
      padding: 25px;
      position: relative;
      width: 100%;
      h3 {
        opacity: 0.5;
        position: relative;
        z-index: 1;
        @include transition(all 0.6s $mainCubic);
      }
      h2 {
        font-weight: 500;
        position: relative;
        z-index: 1;
        @include transition(all 0.6s $mainCubic);
      }
      .circle-btn {
        align-items: center;
        background-color: $mainColor;
        border-radius: 50%;
        color: #fff;
        display: flex;
        font-size: 32px;
        height: 50px;
        justify-content: flex-end;
        padding: 10px;
        position: absolute;
        @include transition(all 0.6s $mainCubic);
        @include transform(translateY(-50%));
        right: 25px;
        top: 50%;
        width: 50px;
      }
    }
    .contact-form-content {
      align-items: center;
      display: flex;
      height: 100%;
      justify-content: center;
      width: 100%;
    }
    .contact-form {
      display: flex;
      flex-direction: column;
      padding: 25px;
      position: relative;
      .row {
        margin-bottom: 25px;
      }
      .row:last-child {
        margin: 0;
      }
      .form-submit-row {
        align-items: center;
        justify-content: space-between;
        p {
          font-size: 12px;
          width: 45%;
          a {
            text-decoration: underline;
            white-space: nowrap;
          }
          a:hover {
            opacity: 0.8;
          }
        }
        .captcha-and-submit {
          align-items: center;
          display: flex;
          p {
            margin: 0;
            width: initial;
          }
        }
      }
      .input-wrapper {
        margin-right: 25px;
      }
      .input-wrapper:last-child {
        margin: 0;
      }
      textarea {
        resize: none;
        width: 100%;
      }
    }
    .contact-form::after {
      background-color: $mainColor;
      bottom: 0;
      content: '';
      height: 5px;
      left: 2px;
      position: absolute;
      width: calc(100% - 4px);
    }
  }
  .contact-form-btn:hover {
    opacity: 0.8;
  }
  .contact-form-info {
    height: 100%;
    overflow: auto;
    padding: 25px;
    position: relative;
    width: 100%;
    .contacts-form-info-item {
      display: inline-block;
      margin: 10px 0;
      width: 100%;
      a {
        margin-left: 5px;
        text-decoration: underline;
      }
      a:hover {
        opacity: 0.8;
      }
      .title-p {
        display: inline-block;
        margin-bottom: 10px;
      }
    }
  }
}
.company-inner-header-active {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  @include transform(translateX(0));
  width: 100%;
  > .text-group {
    height: 0;
    opacity: 0;
    overflow: hidden;
    width: 0;
  }
  .contact-form-wrapper {
    height: 100%;
    left: 0;
    margin: 0;
    width: 100%;
    .contact-form-btn {
      h2,
      h3 {
        color: #fff;
      }
    }
    .contact-form-btn .circle-btn {
      border-radius: 0;
      cursor: default;
      right: 2px;
      height: calc(100% - 4px);
      top: 2px;
      padding-right: 25px;
      @include transform(translateY(0%));
      width: calc(100% - 4px);
      .kcm {
        cursor: pointer;
        font-size: 20px;
        @include transition(all 0.3s $mainCubic);
      }
      .kcm:hover {
        opacity: 0.8;
      }
    }
    .contact-form-btn:hover {
      opacity: 1;
    }
  }
}

.mobile {
  display: none;
}

@media screen and (max-width: 1600px) {
  .company-inner-header {
    > .text-group {
      width: 55%;
    }
    .contact-form-wrapper {
      left: 55%;
      width: 45%;
    }
    .text-group {
      p {
        font-size: 14px;
        line-height: 18px;
      }
    }
    .contact-form-btn-text {
      h3 {
        font-size: 11px;
      }
      h2 {
        font-size: 15px;
      }
    }
  }
  .company-inner-header-active {
    .contact-form-wrapper {
      height: 100%;
      left: 0;
      margin: 0;
      width: 100%;
    }
  }
}
@media screen and (max-width: 1376px) {
  .company-inner-header {
    > .text-group {
      width: 50%;
    }
    .contact-form-wrapper {
      left: 50%;
      width: 50%;
      .contact-form .form-submit-row p {
        font-size: 9px;
        line-height: 14px;
      }
    }
    .text-group {
      p {
        font-size: 12px;
        line-height: 16px;
      }
    }
    .contact-form-btn-text {
      h3 {
        font-size: 10px;
      }
      h2 {
        font-size: 14px;
      }
    }
    .contact-form-info {
      .contacts-form-info-item {
        margin: 5px 0;
        p {
          font-size: 11px;
        }
      }
    }
  }
  .company-inner-header-active {
    .contact-form-wrapper {
      height: 100%;
      left: 0;
      margin: 0;
      width: 100%;
    }
  }
}

@media screen and (max-width: 1000px) {
  .company-inner-header {
    .text-group {
      p {
        font-size: 12px;
        line-height: 14px;
      }
    }
    .contact-form-btn {
      h3 {
        font-size: 9px;
      }
    }
  }
}

@media screen and (max-width: 800px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .company-inner-header {
    position: static;
    margin: 10px 10px 0;
    @include transform(initial);
    > .text-group {
      display: none;
    }
    .contact-form-wrapper {
      height: auto;
      left: 10px;
      margin: 0 10px;
      position: static;
      width: 100%;
    }
    .contact-form-btn {
      h3 {
        letter-spacing: 0.5px;
      }
      .circle-btn {
        span {
          display: none;
        }
      }
    }
    .row {
      flex-direction: column;
    }
    .form-submit-row {
      flex-direction: row;
    }
  }
}
@media screen and (max-width: 600px) {
  .company-inner-header {
    .contact-form-wrapper {
      .contact-form {
        .form-submit-row {
          flex-direction: column;
          > p {
            margin-bottom: 15px;
            text-align: center;
            width: 100%;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 420px) {
  .company-inner-header {
    .contact-form-wrapper {
      .contact-form {
        .form-submit-row {
          flex-direction: column;
          margin: 10px;
          p {
            width: 100%;
            margin-bottom: 20px;
          }
        }
      }
    }
  }
}
</style>

